import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'

const projectName = '/api/blade-platform';
const projectNameNew  = '/api/blade-platform';
const projectNameThree  = '/api/blade-workbench';

const serviceList = {
  state: {
    dictList: null,
  },
  mutations: {
    SET_ServiceList_dictList(state, result) {
      const st = state;
      st.dictList = result;
    },
  },
  actions: {
    //=========================================================V1.3.3预登录
    // 第三方关注内容弹窗接入方式检索下拉菜单查询
    // newStudentOranization() {
    //     return request({
    //         url: `${projectNameNew}/edunewstudentinfo/newStudentOranization`,
    //         method: 'get'
    //     });
    // },
    // 预登陆底部配置-验证url
    platformPrepareLoginButtomConfigCheckLinks(actions, data) {
        return request({
            url: `${projectName}/platformPrepareLoginButtomConfig/checkLinks`,
            method: 'post',
            data
        });
    },
    // 预登陆底部配置-提交
    platformPrepareLoginButtomConfigSubmit(actions, data) {
        return request({
            url: `${projectName}/platformPrepareLoginButtomConfig/submit`,
            method: 'post',
            data,
        });
    },
    // 预登陆底部配置-详情
    platformPrepareLoginButtomConfigDetail(actions, data) {
        return request({
            url: `${projectName}/platformPrepareLoginButtomConfig/detail`,
            method: 'GET',
        });
    },
    // 预登陆页面展示配置详情
    platformPreLoginPageShoConfigDetail(actions, data) {
        return request({
            url: `${projectName}/platformPreLoginPageShoConfig/detail`,
            method: 'get',
        });
    },
    // 预登陆页面展示配置保存
    platformPreLoginPageShoConfigSubmit(actions, data) {
        return request({
            url: `${projectName}/platformPreLoginPageShoConfig/submit`,
            method: 'post',
            data
        });
    },
    // 第三方关注内容弹窗检索获取接入方式
    platformPreLoginPageShoConfigGetAccessWayList(actions, data) {
        return request({
            url: `${projectName}/platformPreLoginPageShoConfig/getAccessWayList`,
            method: 'get',
        });
    },
    // 第三方关注内容弹窗使用环境选项
    getAccessWayList(actions, data) {
        return request({
            url: `${projectNameThree}/platformAppsDict/list`,
            method: 'get',
        });
    },
    // 第三方关注内容弹窗列表查询
    thirdPartyServiceInfoList(actions, data) {
        return request({
            url: `${projectName}/serviceInfo/list`,
            method: 'post',
            data
        });
    },
    // 第三方关注web端配置-服务列表字典
    serviceInfoGetAllServerDict(actions, data) {
        return request({
            url: `${projectName}/serviceInfo/getAllServerDict`,
            method: 'get',
        });
    },
    // 第三方关注web端配置-服务列表字典
    platformCardServiceConfigSubmit(actions, data) {
        return request({
            url: `${projectNameNew}/platformCardServiceConfig/submit`,
            method: 'post',
            data
        });
    },
    // 第三方关注web端配置-服务列表字典
    platformCardServiceConfigQueryServiceCardConfigDetail(actions, data) {
        return request({
            url: `${projectNameNew}/platformCardServiceConfig/queryServiceCardConfigDetail`,
            method: 'post',
            data
        });
    },
  },
};

export default serviceList;
